<template>
  <div>
    <el-tooltip :content="$t(translationPrefix('btnTooltip'))"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button icon round type="danger" @click="modal = true" class="text-nowrap zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-close"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t(translationPrefix('titleText')) }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t(translationPrefix('helpText')) }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountDelete.form.description') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          :placeholder="$t('accountDelete.form.descriptionPlaceholder')"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t(translationPrefix('actionBtnLabel')) }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'account-delete-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        description: '',
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    cardAccount: {
      type: Boolean,
    }
  },
  computed: {
    ...mapState({
      updating: state => state.account_deletion.updating,
      error: state => state.account_deletion.error,
      data: state => state.account_deletion.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error : null;
    }
  },
  methods: {
    ...mapActions(['CreateAccountDeletion', 'LoadAccount']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.CreateAccountDeletion({accountID: this.accountId, payload: this.formDetails}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t(this.translationPrefix('successNotification')),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadAccount(this.accountId);
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        description: '',
      };

      // reset validation errors
      this.$validator.reset()
    },
    translationPrefix(suffix) {
      if (this.cardAccount) {
        return "accountDelete.anonymize." + suffix
      }
      return "accountDelete.new." + suffix
    }
  }
}
</script>
